import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class LookAtAttribute extends AbstractBlock {
  constructor() {
    super('lookat_attribute', t.to('見つめる', 'look_at'));
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    const always = new Blockly.FieldDropdown([
      [t.to('最初だけ', 'only_first_time'), 'false'],
      [t.to('いつまでも', 'always'), 'true'],
    ]);
    block.appendDummyInput().appendField(always, 'always');

    const target = new Blockly.FieldTextInput('block1');
    block
      .appendDummyInput()
      .appendField(`${t.to('ID', 'look_at_the_id')}:`)
      .appendField(target, 'target')
      .appendField(t.to('を見つめる', 'look_at_after'));

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const always = CodeSetting.getFieldValue(block, 'always');
    const target = CodeSetting.getFieldValue(block, 'target');

    const str = CodeSetting.buildAttribute(
      [['lookat', `target:#${target};always:${always};`]],
      attribute
    );
    return [str];
  }
}
